"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var q_play_core_1 = require("@nordicscreen/q-play-core");
var ApiManager = /** @class */ (function () {
    function ApiManager() {
        this.onlineResourceManager = new q_play_core_1.OnlineResourceManager();
    }
    ApiManager.prototype.getAccountByAccountId = function (accountId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/accounts/".concat(accountId));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getPartnerAccount = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/account/partner");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getPartnerAccountContact = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/account/partner-contact");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getLatestAccountsForPartner = function () {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/partner/latest/accounts");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.getUsersForAccountByAccountId = function (accountId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/accounts/".concat(accountId, "/users"));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getUserGlobalPermissions = function () {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/user/permissions/global");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getUserResourcePermissions = function () {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/user/permissions/resource");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getAccountsForUserByUserId = function (userId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/".concat(userId, "/accounts"));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.switchCurrentAccount = function (userId, account) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/".concat(userId, "/switchAccount"), "PUT", JSON.stringify(account));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.elevateToPartner = function (account) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/admin/account/".concat(account.id, "/elevateToPartner"), "PATCH");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateReseller = function (account, newResellerId) {
        var payload = {
            newResellerId: newResellerId,
        };
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/admin/account/".concat(account.id, "/updateReseller"), "PATCH", JSON.stringify(payload));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.addDomainToAccount = function (accountId, domain) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/domain-lock/create", "POST", JSON.stringify({
            account_id: accountId,
            domain: domain,
        }));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.deleteDomainLock = function (id) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/domain-lock/".concat(id), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteQteam = function (qteamId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/".concat(qteamId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.createQteam = function (name, roleIds, userIds) {
        if (userIds === void 0) { userIds = []; }
        var requestBody = JSON.stringify({
            name: name,
            roleIds: roleIds,
            userIds: userIds.length > 0 ? userIds : undefined
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateQteam = function (qteamId, name, roleIds, userIds) {
        var requestBody = JSON.stringify({
            name: name,
            roleIds: roleIds,
            userIds: userIds
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/".concat(qteamId, "/update"), "PUT", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.duplicateQteam = function (qteamId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/".concat(qteamId, "/duplicate"), "POST");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.addUsersToQteam = function (qteamId, userIds) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/add-users/".concat(qteamId), "PATCH", JSON.stringify({ userIds: userIds }));
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.removeUsersFromQteam = function (qteamId, userIds) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/remove-users/".concat(qteamId), "PATCH", JSON.stringify({ userIds: userIds }));
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.getAdminTeamsCount = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/qteam/count-admin-teams", "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.softDeleteAccount = function (account) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/admin/account/".concat(account.id, "/softDeleteAccount"), "DELETE");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateAccountInDatabase = function (accountId, account) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/accounts/".concat(accountId), "PUT", JSON.stringify(account));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateProfileInDatabase = function (userId, user) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/".concat(userId), "PUT", JSON.stringify(user));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateEmailAddress = function (userId, email) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/".concat(userId, "/changeEmail"), "PUT", JSON.stringify(email));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateUserPasswordInDatabase = function (userId, user) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/".concat(userId, "/changePassword"), "PUT", JSON.stringify(user));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.submitAccountNameAndAcceptTerms = function (accountAndUserInfo) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/users/submitAccountNameAndAcceptTerms", "PUT", JSON.stringify(accountAndUserInfo));
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.inviteUser = function (email, qteams) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/accounts/invite/".concat(email), "POST", JSON.stringify({ qteams: qteams }));
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteInvitation = function (invitationId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/account-invitations/".concat(invitationId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.getPresentations = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/list/presentations", "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.deletePresentations = function (presentationId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("api/presentations/delete-all/".concat(presentationId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.clonePresentations = function (presentationId, resourceType) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("api/presentations/clone/".concat(resourceType, "/").concat(presentationId), "POST");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getPlayerPresentations = function (playerId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/playerPresentation/get/".concat(playerId), "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getLatestPublishedPresentations = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("api/presentations/all/published", "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.addPresentation = function (resource) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/playerPresentation/add/".concat(resource.player_id), "POST", JSON.stringify(resource));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateScheduleOnPlayerPresentation = function (playerPresentationId, schedule) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/playerPresentation/".concat(playerPresentationId, "/updateSchedule"), "PATCH", JSON.stringify(schedule));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getPlayerGroups = function () {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/player-groups", "GET");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.deletePlayerPresentation = function (presentationVersionId, playerId) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/playerPresentation/delete/".concat(presentationVersionId, "/player/").concat(playerId), "DELETE", JSON.stringify({
            presentationVersionId: presentationVersionId,
            playerId: playerId,
        }));
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.deletePresentationGroups = function (presentationGroupId) {
        return this.onlineResourceManager
            .makeJSONRequest("/api/presentation-groups/".concat(presentationGroupId), "DELETE")
            .getResponseRaw();
    };
    ApiManager.prototype.deletePlayerGroups = function (playerGroupId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/player-groups/".concat(playerGroupId), "DELETE");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.connectPlayer = function (connectCode, playerName, playerGroup) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/connectPlayer/".concat(connectCode), "POST", JSON.stringify({
            connectCode: connectCode,
            playerName: playerName,
            playerGroup: playerGroup,
        }));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updatePlayerGroup = function (playerId, groupId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/player/".concat(playerId, "/group"), "PATCH", JSON.stringify({ groupId: groupId }));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updatePresentationGroup = function (presentationData, groupId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/presentation/".concat(presentationData.presentation_version_id, "/group"), "PATCH", JSON.stringify(__assign(__assign({}, presentationData), { groupId: groupId })));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.deletePlayer = function (playerId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/player/".concat(playerId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteIntegrations = function (integrationIds) {
        var _this = this;
        var deleteRequests = integrationIds.map(function (id) {
            return _this.onlineResourceManager.makeRequest("/api/integration/".concat(id), "DELETE").getResponseRaw();
        });
        return Promise.all(deleteRequests);
    };
    ApiManager.prototype.deleteAppIntegrations = function (integrationIds) {
        var _this = this;
        var deleteRequests = integrationIds.map(function (id) {
            return _this.onlineResourceManager.makeRequest("/api/app-integrations/".concat(id), "DELETE").getResponseRaw();
        });
        return Promise.all(deleteRequests);
    };
    ApiManager.prototype.getLegacyIntegrations = function () {
        return this.onlineResourceManager.makeJSONRequest("/api/integrations", "GET").getDataAsJSON();
    };
    ApiManager.prototype.getIntegrationById = function (integrationId) {
        return this.onlineResourceManager.makeJSONRequest("/api/integration/".concat(integrationId), "GET").getDataAsJSON();
    };
    ApiManager.prototype.getIntegrationStatus = function (integrationId) {
        return this.onlineResourceManager.makeJSONRequest("/api/".concat(integrationId, "/status"), "GET").getDataAsJSON();
    };
    ApiManager.prototype.getIntegrationResource = function (integrationId, resourceId) {
        var endpoint = "/api/integration/".concat(integrationId, "/").concat(resourceId);
        return this.onlineResourceManager.makeJSONRequest(endpoint, "GET").getResponseRaw();
    };
    ApiManager.prototype.getPresentationGroups = function (presentationType) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/presentation-groups/".concat(presentationType.toUpperCase()), "GET");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.toggleCommand = function (command, playerId) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/players/".concat(playerId, "/toggleCommand/").concat(command), "PUT", JSON.stringify({ playerId: playerId, command: command }));
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.updatePlayerName = function (playerId, playerName) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/player/".concat(playerId, "/name"), "PATCH", JSON.stringify({ playerName: playerName }));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateIntegrationName = function (integrationId, integrationName) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/integrations/".concat(integrationId, "/name"), "PATCH", JSON.stringify({ name: integrationName }));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updatePlayerGroupName = function (playerGroupId, groupName) {
        return this.onlineResourceManager.makeJSONRequest("/api/player/".concat(playerGroupId, "/update-name"), "PATCH", JSON.stringify({ id: playerGroupId, name: groupName })).getDataAsJSON();
    };
    ApiManager.prototype.updatePresentationGroupName = function (presentationGroupId, groupName, type) {
        return this.onlineResourceManager.makeJSONRequest("/api/presentation/".concat(presentationGroupId, "/").concat(type, "/update-groupname"), "PATCH", JSON.stringify({ id: presentationGroupId, name: groupName, type: type })).getDataAsJSON();
    };
    ApiManager.prototype.getPlayerAmount = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/player/amount", "GET");
        return onlineResource.getDataAsJSON();
    };
    // Autoconnect disabled for now.
    // updatePlayerAutoconnectId(playerId: number, autoconnectId: string) {
    //     const onlineResource = this.onlineResourceManager.makeJSONRequest(
    //         `/api/player/${playerId}/autoconnectid/${autoconnectId}`,
    //         "PATCH",
    //         JSON.stringify({ autoconnectId: autoconnectId }),
    //     );
    //     return onlineResource.getDataAsJSON();
    // }
    // toggleAutoconnect(value: boolean, playerId: number) {
    //     const onlineResouce = this.onlineResourceManager.makeJSONRequest(
    //         `/api/players/${playerId}/toggleAutoconnect/${value}`,
    //         "PUT",
    //         JSON.stringify({ playerId: playerId, value: value }),
    //     );
    //     return onlineResouce.getDataAsJSON();
    // }
    ApiManager.prototype.updatePowerManagement = function (playerId, data) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/players/".concat(playerId, "/power-management"), "PATCH", JSON.stringify(data));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getTeamRoles = function () {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/team/roles");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getResourceRoles = function () {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/resource/roles");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getQteams = function () {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/qteams");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getQteamsForAnAccount = function (accountId) {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/accounts/".concat(accountId, "/qteams"));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getResourceGroupQteamsWithRoles = function (type, groupId) {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/qteam/".concat(type, "-group/").concat(groupId, "/group-qteams-with-roles"));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getResourceQteamsWithRoles = function (type, resourceId) {
        var onlineResource = this.onlineResourceManager.makeRequest("/api/qteams/".concat(type, "/").concat(resourceId, "/qteams-with-roles"));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.updateQteamRoles = function (type, resourceId, qteamId, role, resourceName) {
        var url = "/api/qteam/".concat(type, "/").concat(resourceId, "/qteam/").concat(qteamId, "/updateQteamRoles");
        var payload = {
            role: role,
            resourceName: resourceName
        };
        var onlineResource = this.onlineResourceManager.makeJSONRequest(url, "PATCH", JSON.stringify(payload));
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.getScreenshot = function (token) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/screenshots/get/".concat(token), "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.removeUserFromAccount = function (userId) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/accounts/remove/user/".concat(userId), "POST");
        return onlineResouce.getResponseData();
    };
    ApiManager.prototype.updateAccountSettings = function (accountSettings) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/account/account-settings", "PATCH", JSON.stringify(accountSettings));
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.updateUserRoles = function (userId, roles) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/user/".concat(userId, "/update/roles"), "PUT", JSON.stringify({ roles: roles }));
        return onlineResouce.getResponseRaw();
    };
    ApiManager.prototype.getRootFolderId = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/media-library/folders/get-root", "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.deleteMedia = function (collectionName, id) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/media-library/folders/".concat(collectionName, "/delete-file/").concat(id), "DELETE");
        return onlineResouce.getResponseData();
    };
    ApiManager.prototype.createEvent = function (eventData) {
        var _a, _b, _c, _d, _e;
        var requestBody = JSON.stringify({
            title: eventData.title,
            active: (_a = eventData.active) !== null && _a !== void 0 ? _a : undefined,
            start: eventData.start ? Number(eventData.start) : null,
            end: eventData.end ? Number(eventData.end) : null,
            presentation_id: (_b = eventData.presentation_id) !== null && _b !== void 0 ? _b : undefined,
            presentation_version_id: (_c = eventData.presentation_version_id) !== null && _c !== void 0 ? _c : undefined,
            presentation_name: (_d = eventData.presentation_name) !== null && _d !== void 0 ? _d : undefined,
            time_schedule: (_e = eventData.time_schedule) !== null && _e !== void 0 ? _e : undefined
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/store", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateEvent = function (eventId, eventData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var requestBody = JSON.stringify({
            id: (_a = eventData.id) !== null && _a !== void 0 ? _a : undefined,
            title: (_b = eventData.title) !== null && _b !== void 0 ? _b : undefined,
            active: (_c = eventData.active) !== null && _c !== void 0 ? _c : undefined,
            start: (_d = eventData.start) !== null && _d !== void 0 ? _d : undefined,
            end: (_e = eventData.end) !== null && _e !== void 0 ? _e : undefined,
            presentation_id: (_f = eventData.presentation_id) !== null && _f !== void 0 ? _f : undefined,
            presentation_version_id: (_g = eventData.presentation_version_id) !== null && _g !== void 0 ? _g : undefined,
            presentation_name: (_h = eventData.presentation_name) !== null && _h !== void 0 ? _h : undefined,
            time_schedule: (_j = eventData.time_schedule) !== null && _j !== void 0 ? _j : undefined
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/".concat(eventId, "/update"), "PUT", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateEventActive = function (eventId, isActive) {
        var requestBody = JSON.stringify({
            active: isActive
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/".concat(eventId, "/activate"), "PATCH", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteEventById = function (eventId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/".concat(eventId, "/delete"), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.bulkDeleteEvents = function (eventIds) {
        var requestBody = JSON.stringify({
            event_ids: eventIds
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/events/delete", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.getEvents = function () {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/event-management", "GET");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.getPlayerEvents = function (playerIds) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/player-events?playerIds=".concat(playerIds), "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.addEventsToPlayers = function (playerIds, eventIds) {
        var requestBody = JSON.stringify({
            player_ids: playerIds,
            event_ids: eventIds
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/event-management/player-events/add-event", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deletePlayerEvent = function (playerId, eventId) {
        var url = "/api/event-management/player-events/".concat(playerId, "/").concat(eventId);
        var onlineResource = this.onlineResourceManager.makeJSONRequest(url, "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.addOAuth2Client = function (name, clientId, clientSecret, active) {
        var requestBody = JSON.stringify({
            name: name,
            client_id: clientId,
            client_secret: clientSecret,
            active: active
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/oAuth2Client", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateOAuth2Client = function (id, data) {
        var requestBody = JSON.stringify(data);
        var url = "/api/oAuth2Client/".concat(id);
        var onlineResource = this.onlineResourceManager.makeJSONRequest(url, "PATCH", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteOAuth2Client = function (id) {
        var url = "/api/oAuth2Client/".concat(id);
        var onlineResource = this.onlineResourceManager.makeJSONRequest(url, "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.getMetadata = function () {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/metadata", "GET");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.getSingleMetadata = function (id) {
        var onlineResouce = this.onlineResourceManager.makeJSONRequest("/api/metadata/".concat(id), "GET");
        return onlineResouce.getDataAsJSON();
    };
    ApiManager.prototype.createMetadata = function (metadataData) {
        var requestBody = JSON.stringify({
            meta_key: metadataData.meta_key,
            description: metadataData.description,
            key_value_pairs: metadataData.key_value_pairs ? JSON.stringify(metadataData.key_value_pairs) : undefined,
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateMetadata = function (metadataId, metadataData) {
        var _a, _b;
        var requestBody = JSON.stringify({
            meta_key: (_a = metadataData.meta_key) !== null && _a !== void 0 ? _a : undefined,
            description: (_b = metadataData.description) !== null && _b !== void 0 ? _b : undefined,
            key_value_pairs: metadataData.key_value_pairs ? JSON.stringify(metadataData.key_value_pairs) : undefined,
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata/".concat(metadataId), "PATCH", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteMetadata = function (metadataId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata/".concat(metadataId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.syncMetadataToPlayer = function (playerId, metadata) {
        var requestBody = JSON.stringify({ metadata: metadata });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata/sync-to/player/".concat(playerId), "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.getPlayerMetadata = function (playerId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata/player/".concat(playerId, "/playerMetadata"), "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.deleteMetadataFromPlayer = function (playerId, metadataId) {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/metadata/".concat(metadataId, "/player/").concat(playerId), "DELETE");
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.createAppTemplate = function (templateData) {
        var requestBody = JSON.stringify({
            name: templateData.name,
            app_id: templateData.app_id,
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/app-templates/store", "POST", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.updateAppTemplate = function (templateId, templateData) {
        var requestBody = JSON.stringify({
            name: templateData.name,
            template: templateData.template,
        });
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/app-templates/update/".concat(templateId), "PUT", requestBody);
        return onlineResource.getResponseRaw();
    };
    ApiManager.prototype.deleteAppTemplate = function (templateId) {
        return this.onlineResourceManager.makeJSONRequest("/api/app-templates/delete/".concat(templateId), "DELETE").getResponseRaw();
    };
    ApiManager.prototype.getGroupHasPresentationFlags = function () {
        var onlineResource = this.onlineResourceManager.makeJSONRequest("/api/account/presentation-groups/has-presentation", "GET");
        return onlineResource.getDataAsJSON();
    };
    ApiManager.prototype.genericApiCall = function (url, method, postData) {
        if (method === void 0) { method = "GET"; }
        return __awaiter(this, void 0, void 0, function () {
            var onlineResouce;
            return __generator(this, function (_a) {
                onlineResouce = this.onlineResourceManager.makeJSONRequest(url, method, JSON.stringify(postData));
                return [2 /*return*/, onlineResouce.getDataAsJSON()];
            });
        });
    };
    return ApiManager;
}());
exports.default = new ApiManager();
